import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { Field, reduxForm, Form, change, submit } from 'redux-form';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';
import { connect } from 'react-redux';
import IconButton from 'material-ui/IconButton';
import Close from 'material-ui-icons/Cancel';

import managePortfolioData from '../actions/VXC/managePortfolios';
import storeInstitutionData from '../actions/VXC/storeInstitutionData';

import validationHelper from '../helpers/ValidationHelper';
import renderCheckBoxItem from '../helpers/RenderCheckBoxItem';
import renderTextField from '../helpers/RenderTextFiled';

const styles = theme => ({
  card: {
    display: 'flex',
    boxShadow: 'none',
  },
  content: {
    flex: '1 0 auto',
  },
  paperStyle: {
    width: '92%',
    height: '70%',
    display: 'inline-block',
    margin: 20,
    marginTop: '5vh'
  },
  marginStyle: {
    margin: 0
  },
  radioGroupMask: {
    width: '300px',
    paddingTop: '20px'
  },
  editGroup: {
    marginLeft: '0 !important',
    width: '150px'
  },

  editGroupCB: {
    marginLeft: '0 !important',
  },

  textField: {
    width: 200,
  },
  buttonStyle: {
    marginTop: 10,
    marginBottom: 15,
    textAlign: 'center'
  },
  formControl: {
    margin: theme.spacing.unit - 5,
    justifyContent: 'center'
  },
  adddressTypeDiv: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  closeIcon: {
    right: '2%',
    top: '2%'
  }
});

const validate = (values, props) => {
  const errors = validationHelper.validateRequired(['addressType', 'country', 'addressLine1', 'city', 'county', 'state', 'postalCode'], values);

  const lengthValidation = [
    { field: 'addressLine1', label: 'Address Line 1', value: values.addressLine1, min: 1, max: 50 },
    { field: 'addressLine2', label: 'Address Line 2', value: values.addressLine2, min: 1, max: 50 },
    { field: 'city', label: 'City', value: values.city, min: 1, max: 50 },
    { field: 'postalCode', label: 'Postal Code', value: values.postalCode, min: 1, max: 20 },
    { field: 'county', label: 'County', value: values.county, min: 1, max: 50 },
  ];
  validationHelper.validateLength(errors, lengthValidation);
  return errors;
};

class PortfolioGroupForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      saved: false,
      delayAndSuppression: [],
      itemsChecked: false,
      showSaveButton: [0, 0],
      captureFieldNames: [],
      previousCapturedFieldNames: [],
    };
  }

  componentDidMount() {
    if (localStorage.institutionData !== undefined) {
      this.loadData();
    }
  }

  componentDidUpdate(prevState) {
    if (this.state.captureFieldNames !== prevState.captureFieldNames &&
      this.state.captureFieldNames.length > 0) {
      this.state.captureFieldNames.forEach((fld) => {
        if (localStorage.institutionData !== undefined) {
          const storedData = JSON.parse(localStorage.getItem('institutionData'));
          storedData.forEach((d) => {
            this.props.dispatch(change('PortfolioGroupForm', d.portfolioId, 'Yes'));
            if (fld.includes(`${d.portfolioId}_SD`)) {
              this.props.dispatch(change('PortfolioGroupForm', fld, d.suppressionDate));
            } else if (fld.includes(`${d.portfolioId}_DT`)) {
              this.props.dispatch(change('PortfolioGroupForm', fld, d.delayDate));
            }
          })
        }
      })
    }
  }

  handleSetDefault = (fld) => {
    this.setState({ previousCapturedFieldNames: [...this.state.captureFieldNames] });
    fld.forEach((v) => {
      this.props.dispatch(change('PortfolioGroupForm', v, v.includes('DT') ? '0' : '10'));
    })
  }

  handleClosePopUp = () => {

    this.props.handleAddressClose();
  }

  handleGroupSave = (event) => {
    let institutionData = [];

    institutionData = this.groupConstructor(event);

    let rules = [];

    if (!this.props.newRecord) {
      rules = this.rulesConstructor(institutionData);

      const portfolioData = {
        portfolioId: this.props.portfolioId,
        customerId: this.props.customerId,
        rules
      }

      localStorage.setItem('institutionData', JSON.stringify(institutionData));
      this.props.dispatch(storeInstitutionData(institutionData));

      this.props.actions.managePortfolioData(portfolioData, this.props.data.config, this);
    } else {
      this.handleClosePopUp();
    }

  }

  loadData = () => {
    if (localStorage.getItem('institutionData')) {
      const data = JSON.parse(localStorage.getItem('institutionData'));
      const allFieldNames = [...this.state.captureFieldNames];
      const dAndS = [...this.state.delayAndSuppression];
      data.forEach((d) => {
        // this.props.dispatch(change('PortfolioGroupForm', d.portfolioId, true));
        allFieldNames.push(`${d.portfolioId}_SD`)
        allFieldNames.push(`${d.portfolioId}_DT`)
        dAndS.push({ portfolioId: d.portfolioId })
      })
      this.setState({
        captureFieldNames: allFieldNames,
        delayAndSuppression: dAndS,
        itemsChecked: true
      })
    }
  }

  handleCheckChange = (event) => {
    this.props.dispatch(change('PortfolioGroupForm', event.target.name, event.target.checked))
    if (event.target.checked) {
      this.props.dispatch(change('PortfolioGroupForm', event.target.name, true))
      this.setState({ delayAndSuppression: [...this.state.delayAndSuppression, { portfolioId: event.target.value }] });
      this.setState({ captureFieldNames: [...this.state.captureFieldNames, `${event.target.name}_SD`, `${event.target.name}_DT`], itemsChecked: true },
        () => {
          const arr1 = this.state.captureFieldNames.sort();
          const arr2 = this.state.previousCapturedFieldNames.sort();
          const result = [];
          for (let i = 0; i < arr1.length; i += 1) {
            if (arr2.indexOf(arr1[i]) === -1) {
              result.push(arr1[i]);
            }
          }
          if (result) {
            this.handleSetDefault(result);
          }
        }
      );
    } else {
      const val = [...this.state.delayAndSuppression];
      val.splice(val.indexOf(val.find(v => v.portfolioId === event.target.name)), 1);
      const fieldNames = [...this.state.captureFieldNames];
      fieldNames.splice(fieldNames.indexOf(`${event.target.name}_DT`), 1);
      fieldNames.splice(fieldNames.indexOf(`${event.target.name}_SD`), 1);
      this.setState({ delayAndSuppression: val, captureFieldNames: fieldNames });
      if (val.length < 1) {
        this.setState({ itemsChecked: false });
      }
    }
  }

  submitForm = () => {
    this.props.dispatch(submit('PortfolioGroupForm'));
    // this.props.actions.saveCustomerAddress(this.props.customerId, primaryLocation, this.props.data.config, this);
  }


  groupConstructor(event) {
    const institutionData = [];
    Object.keys(event).forEach((key) => {
      this.state.delayAndSuppression.forEach((portfolio) => {
        if (portfolio.portfolioId === key) {
          if (event[key] === true || event[key] === 'Yes') {
            const groupDetail = {
              delayDate: event[`${key}_DT`] ? event[`${key}_DT`] : '0',
              suppressionDate: event[`${key}_SD`] ? event[`${key}_SD`] : '10',
              portfolioId: key
            };
            institutionData.push(groupDetail);
          }
        }
      });
    });
    return institutionData;
  }

  rulesConstructor(institutionData) {
    const rules = [];
    this.props.customerData.forEach((rule) => {
      if (rule.ruleId === 'active_port') {
        const ruleWithInst = rule;
        ruleWithInst.institutions = institutionData;
        rules.push(ruleWithInst);
      }
      else {
        rules.push(rule);
      }
    });
    return rules;
  }

  checkToSave = (event) => {
    if (event.target.value.length > 0) {
      const val = this.state.showSaveButton + 1;
      this.setState({ showSaveButton: val })
    } else {
      const val = this.state.showSaveButton - 1;
      this.setState({ showSaveButton: val })
    }
  }

  render() {
    const { classes, handleSubmit } = this.props;
    let renderReportOptions = <div />

    if (this.props.portfolioData) {
      renderReportOptions = this.props.portfolioData.map((report) => {
        return (
          <div key={report.portfolioId}>
            <div style={{ margin: '0 0 0 7%', padding: 0 }}>
              <Field
                name={report.portfolioId}
                component={renderCheckBoxItem}
                checked={!!this.state.delayAndSuppression.find(v => v.portfolioId === report.portfolioId)}
                option={{ id: report.portfolioId, label: report.portfolioId }}
                className={classes.editGroupCB}
                label={report.name}
                handleCheckChange={this.handleCheckChange}
              />
            </div>
            {this.state.delayAndSuppression.find(val => val.portfolioId === report.portfolioId) ?
              <table style={{ margin: '0 0 5% 10%', padding: 0 }}>
                <tbody>
                  <tr>
                    <td>
                      <div>
                        <Field
                          name={`${report.portfolioId}_SD`}
                          component={renderTextField}
                          label="Suppression Days"
                          className={classes.editGroup}
                          divClassName={classes.marginStyle}
                        />
                      </div>
                    </td>
                    <td>
                      <div>
                        <Field
                          name={`${report.portfolioId}_DT`}
                          component={renderTextField}
                          label="Delay Time"
                          className={classes.editGroup}
                          divClassName={classes.marginStyle}
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              : null}
          </div>
        )
      })
    }

    return (
      <Form key="PortfolioGroupForm" onSubmit={handleSubmit(this.handleGroupSave)}>
        <div className={classes.adddressTypeDiv} style={{ marginTop: '25px' }}>
          <span />
          <Typography variant="title" className="lightH2">
            <span className="pageHeader" style={{ fontSize: '24px' }}>Edit Groups</span>
          </Typography>
          <IconButton title="close" className={classes.closeIcon} onClick={this.props.handleAddressClose}>
            <Close color="disabled" />
          </IconButton>
        </div>
        <span />
        <div style={{ height: '400px', width: '600px', overflowY: 'scroll' }}>
          {renderReportOptions}
        </div>
        <div className={classes.buttonStyle}>
          <div color="danger" style={this.state.saved ? { visibility: 'visible', color: 'red', fontWeight: 'bold' } : { visibility: 'hidden' }}>{this.state.message}</div>
          <Button variant="raised" style={{ background: '#002057' }} type="button" onClick={this.submitForm} id="address-submit">Save</Button>
        </div>
      </Form>
    );
  }
}

PortfolioGroupForm.propTypes = {
  classes: PropTypes.shape().isRequired
};

const mapStateToProps = state => ({
  data: {
    config: state.config.config
  }
});

const mapDispatchToProps = dispatch => ({
  actions: {
    managePortfolioData: (portfolioData, config, self) => {
      self.setState({ saving: true });
      dispatch(managePortfolioData(portfolioData, config)).then((p) => {
        if (p.action.type === 'ADD_EDIT_PORTFOLIOS_SAVE_FULFILLED') {
          self.setState({ saving: false, saved: true, message: 'Record saved', openDialog: true, itemsChecked: false });
        }
      })
    }
  }
});

const ReduxForm = withStyles(styles, { withTheme: true })(reduxForm({
  form: 'PortfolioGroupForm',
  validate
})(PortfolioGroupForm));

const ConnectedAddressForm = connect(mapStateToProps, mapDispatchToProps)(ReduxForm);

export default ConnectedAddressForm;


// WEBPACK FOOTER //
// ./src/containers/PortfolioGroupForm.js